import type { AxiosInstance } from "axios";
import { internalApiClient } from "@/marketing/infrastructure/http/httpClient";
import type {
  CampaignSettlement,
  UpsertCampaignSettlementRequest,
} from "@/marketing/models/campaignSettlement";
import { pathSegment } from "@/marketing/lib/pathSegment";

const BASE_PATH = "/influencer/campaigns";

export class CampaignSettlementAPIClient {
  // Settlements are served by internal-api.
  constructor(private readonly client: AxiosInstance = internalApiClient) {}

  public async listCampaignSettlements(
    campaignId: string,
  ): Promise<CampaignSettlement[]> {
    const { data } = await this.client.get<CampaignSettlement[]>(
      `${BASE_PATH}/${pathSegment(campaignId)}/settlements`,
    );
    return data;
  }

  public async getCampaignInfluencerSettlement(
    campaignId: string,
    influencerId: string,
  ): Promise<CampaignSettlement | null> {
    try {
      const { data } = await this.client.get<CampaignSettlement>(
        `${BASE_PATH}/${pathSegment(campaignId)}/influencers/${pathSegment(influencerId)}/settlement`,
      );
      return data;
    } catch (error) {
      if (
        typeof error === "object" &&
        error !== null &&
        "isAxiosError" in error &&
        (error as { response?: { status?: number } }).response?.status === 404
      ) {
        return null;
      }
      throw error;
    }
  }

  public async upsertCampaignInfluencerSettlement(
    campaignId: string,
    influencerId: string,
    request: UpsertCampaignSettlementRequest,
  ): Promise<CampaignSettlement> {
    const { data } = await this.client.put<CampaignSettlement>(
      `${BASE_PATH}/${pathSegment(campaignId)}/influencers/${pathSegment(influencerId)}/settlement`,
      request,
    );
    return data;
  }
}

export const campaignSettlementAPIClient = new CampaignSettlementAPIClient();
